import { Box } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { KeyDriveBodyMin } from "../Fonts/Body/KeyDriveBodyMin";
import { useTranslation } from "react-i18next";

export const KeydriveBallon = () => {

    const { t } = useTranslation();

    return (
        <Box
            width="100%"
            height="58px"
            border="1px solid #EAEAEA"
            borderColor="#EAEAEA"
            borderRadius="4px"
            display="flex"
            alignItems="center"
            mt="12px"
        >   
            <Box
                height="58px"
                width="4px"
                bgcolor="#22638D"
                sx={{
                    borderTopLeftRadius: "4px",
                    borderBottomLeftRadius: "4px",
                }}
                mr="8px"
            />
            <Box
                height="100%"
                display="flex"
                alignItems="center"
            >
                <Box
                    width="36px"
                    height="36px"
                    borderRadius="50%"
                    textAlign="center"
                    bgcolor="#E9EFF4"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <InfoIcon sx={{ width: "16px", height: "16px", color: "#22638D" }} />
                </Box>
            </Box>
            <Box ml="8px">
                <KeyDriveBodyMin
                    color="#2D2D2D"
                    needBold
                    needEllipses={false}
                    text={t("AdminConsole.Preferences.OrgPreferences")}
                />

                <KeyDriveBodyMin
                    color="#575757"
                    needBold
                    needEllipses={false}
                    text={t("AdminConsole.Preferences.OrgPreferencesSub")}
                />
            </Box>
        </Box>
    );
}